import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { apiRequest, getFirst } from "@/api/formSys";
export default {
  name: "devCustom",
  data: function data() {
    return {
      config: [],
      tableData: [],
      formType: "",
      formData: {},
      dialogFormVisible: false,
      agentInfo: {},
      centerDialogVisible: false,
      copyID: "",
      copyInfo: {
        copy_id: 0,
        //粘贴的id
        oldName: "",
        //复制的名字
        newName: "" //粘贴的名字
      },

      isShowCopy: false
    };
  },
  props: {
    formId: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var rs, formApi, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getFirst({
                formId: _this.formId
              });
            case 2:
              rs = _context.sent;
              if (rs.code == 0) {
                formApi = rs.data.formConfig.formApi;
                for (i = 0; i < formApi.length; i++) {
                  if (formApi[i].name === 'copy') {
                    _this.isShowCopy = true;
                  }
                }
                _this.config = rs.data.formConfig.formParam;
              }
              _this.getTableData();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getTableData: function getTableData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var rs;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return apiRequest({
                formId: _this2.formId,
                apiName: "list"
              });
            case 2:
              rs = _context2.sent;
              if (rs.code == 0 && rs.data.code == 0) {
                _this2.tableData = rs.data.data.list;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    add: function add() {
      this.formType = "add";
      this.formData = JSON.parse(JSON.stringify({})), this.dialogFormVisible = true;
    },
    create: function create() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var rs;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return apiRequest({
                formId: _this3.formId,
                apiName: "add",
                data: _this3.formData
              });
            case 2:
              rs = _context3.sent;
              if (rs.code == 0 && rs.data.code == 0) {
                _this3.$message({
                  type: 'success',
                  message: '创建成功!'
                });
                _this3.dialogFormVisible = false;
                _this3.getTableData();
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    edit: function edit(row) {
      this.formType = "update";
      this.formData = JSON.parse(JSON.stringify(row));
      this.dialogFormVisible = true;
    },
    update: function update() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var rs;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return apiRequest({
                formId: _this4.formId,
                apiName: "update",
                data: _this4.formData
              });
            case 2:
              rs = _context4.sent;
              if (rs.code == 0 && rs.data.code == 0) {
                _this4.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                _this4.dialogFormVisible = false;
                _this4.getTableData();
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    del: function del(row) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this5.$confirm('是否确认删除此项?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                var delData, rs;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      delData = {};
                      _this5.config.forEach(function (r) {
                        if (r.isPrimaryKey == 1) {
                          delData[r.paramName] = row[r.paramName];
                        }
                      });
                      _context5.next = 4;
                      return apiRequest({
                        formId: _this5.formId,
                        apiName: "delete",
                        data: delData
                      });
                    case 4:
                      rs = _context5.sent;
                      if (rs.code == 0 && rs.data.code == 0) {
                        _this5.$message({
                          type: 'success',
                          message: '删除成功!'
                        });
                        _this5.dialogFormVisible = false;
                        _this5.getTableData();
                      }
                    case 6:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              })));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    copy: function copy(e) {
      this.agentInfo = e;
      this.centerDialogVisible = true;
    },
    copySuc: function copySuc() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var i, data, res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(_this6.copyID === "")) {
                _context7.next = 4;
                break;
              }
              _this6.$message({
                type: 'warning',
                message: '请填写粘贴表单ID!'
              });
              _context7.next = 12;
              break;
            case 4:
              for (i = 0; i < _this6.config.length; i++) {
                if (_this6.config[i].isPrimaryKey === 1) {
                  _this6.formId = _this6.config[i].formId;
                  _this6.copyInfo.copy_id = _this6.agentInfo[_this6.config[i].paramName];
                  _this6.copyInfo.oldName = _this6.config[i].paramName;
                  _this6.copyInfo.newName = "copy_" + _this6.config[i].paramName;
                }
              }
              data = {};
              /**
               * copy_channel_id被复制的ID
               * channel_id粘贴的ID
               */
              data[_this6.copyInfo.oldName] = parseInt(_this6.copyID);
              data[_this6.copyInfo.newName] = _this6.copyInfo.copy_id;
              _context7.next = 10;
              return apiRequest({
                formId: _this6.formId,
                apiName: "copy",
                data: data
              });
            case 10:
              res = _context7.sent;
              if (res.code === 0) {
                _this6.copyID = "";
                _this6.$message({
                  type: 'success',
                  message: '复制成功!'
                });
                _this6.centerDialogVisible = false;
                _this6.getTableData();
              }
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  }
};